import { c as _c } from "react/compiler-runtime";
import { Searchbar } from "@components/header/searchbar";
import { FilterChipsBar } from "@components/common/faro-table/faro-table-filter/filter-chips-bar";
import { FilterToggleButton } from "@components/common/faro-table/faro-table-filter/filter-toggle-button";
import { Stack } from "@mui-wrapper";
import { Text } from "@flat-ui";
import { useState } from "react";
import { useMediaQueryList } from "@hooks/use-media-query";
import { LoadingWrapper } from "@context-providers/loading-state-context";
import { isAnyFilterAppliedIn } from "@hooks/table-filters/use-filter-query-params";
import { useSearchParams } from "react-router-dom";
import { EntitiesToolbarMobile } from "@components/common/toolbar/entities-toolbar-mobile";

/**
 * Height of flat-ui's search field. The sort and export sections take the same height and centre
 * their content, so every item shares the field's centre line. The row itself stays top-aligned,
 * so a validation message under the search field does not push the other items down.
 */
const TOOLBAR_ROW_HEIGHT = "2.25rem";
/** Toolbar to show on top of page that displays entities */
export function EntitiesToolbar(t0) {
  const $ = _c(65);
  const {
    sortActions,
    numberOfRows,
    totalNumberOfRows,
    exportComponent,
    toolbarEntityName,
    isLoading: t1,
    shouldShowRowsLabel: t2,
    shouldSkipValidation: t3,
    shouldStack: t4,
    shouldRemoveTopMargin: t5,
    filterChips,
    mobileAction
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const shouldShowRowsLabel = t2 === undefined ? true : t2;
  const shouldSkipValidation = t3 === undefined ? false : t3;
  const shouldStack = t4 === undefined ? false : t4;
  const shouldRemoveTopMargin = t5 === undefined ? false : t5;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const [searchParams] = useSearchParams();
  let t6;
  if ($[0] !== searchParams) {
    t6 = () => isAnyFilterAppliedIn(searchParams);
    $[0] = searchParams;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const [isFilterBarOpen, setIsFilterBarOpen] = useState(t6);
  const defaultTopMargin = isScreenSmOrSmaller ? "1rem" : "1.25rem";
  const topMargin = shouldRemoveTopMargin ? 0 : defaultTopMargin;
  const hasTotalRows = totalNumberOfRows !== undefined;
  const shouldRenderRowsLabel = shouldShowRowsLabel && (hasTotalRows || numberOfRows > 0);
  const entityLabel = (hasTotalRows ? totalNumberOfRows : numberOfRows) === 1 ? toolbarEntityName : `${toolbarEntityName}s`;
  let t7;
  if ($[2] !== entityLabel || $[3] !== hasTotalRows || $[4] !== numberOfRows || $[5] !== shouldRenderRowsLabel || $[6] !== totalNumberOfRows) {
    t7 = shouldRenderRowsLabel && <Text variant="bodyS" component="var">{hasTotalRows ? `${numberOfRows} of ${totalNumberOfRows} ${entityLabel}` : `${numberOfRows} ${entityLabel}`}</Text>;
    $[2] = entityLabel;
    $[3] = hasTotalRows;
    $[4] = numberOfRows;
    $[5] = shouldRenderRowsLabel;
    $[6] = totalNumberOfRows;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const rowsLabel = t7;
  let t8;
  if ($[8] !== isLoading || $[9] !== sortActions) {
    t8 = sortActions && <LoadingWrapper isLoading={isLoading}><Stack sx={{
        flex: 1,
        minHeight: TOOLBAR_ROW_HEIGHT,
        justifyContent: "center"
      }}>{sortActions}</Stack></LoadingWrapper>;
    $[8] = isLoading;
    $[9] = sortActions;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const sortActionsWrapper = t8;
  let t9;
  if ($[11] !== filterChips || $[12] !== isFilterBarOpen || $[13] !== sortActionsWrapper) {
    t9 = filterChips ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: 1,
      minHeight: TOOLBAR_ROW_HEIGHT
    }}><FilterToggleButton isOpen={isFilterBarOpen} onToggle={() => setIsFilterBarOpen(!isFilterBarOpen)} />{sortActionsWrapper}</Stack> : sortActionsWrapper;
    $[11] = filterChips;
    $[12] = isFilterBarOpen;
    $[13] = sortActionsWrapper;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const sortAndFilterActions = t9;
  let t10;
  if ($[15] !== filterChips || $[16] !== isFilterBarOpen) {
    t10 = filterChips && isFilterBarOpen && <FilterChipsBar filterChips={filterChips} />;
    $[15] = filterChips;
    $[16] = isFilterBarOpen;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const filterChipsBar = t10;
  if (isScreenSmOrSmaller) {
    let t11;
    if ($[18] !== filterChips || $[19] !== isFilterBarOpen) {
      t11 = filterChips && <FilterToggleButton isIconOnly={true} isOpen={isFilterBarOpen} onToggle={() => setIsFilterBarOpen(!isFilterBarOpen)} />;
      $[18] = filterChips;
      $[19] = isFilterBarOpen;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    const t12 = (totalNumberOfRows ?? numberOfRows) > 0;
    let t13;
    if ($[21] !== exportComponent || $[22] !== filterChipsBar || $[23] !== mobileAction || $[24] !== rowsLabel || $[25] !== shouldSkipValidation || $[26] !== sortActionsWrapper || $[27] !== t11 || $[28] !== t12 || $[29] !== topMargin) {
      t13 = <EntitiesToolbarMobile topMargin={topMargin} mobileAction={mobileAction} filterButton={t11} sortActions={sortActionsWrapper} rowsLabel={rowsLabel} exportComponent={exportComponent} shouldSkipValidation={shouldSkipValidation} hasRows={t12}>{filterChipsBar}</EntitiesToolbarMobile>;
      $[21] = exportComponent;
      $[22] = filterChipsBar;
      $[23] = mobileAction;
      $[24] = rowsLabel;
      $[25] = shouldSkipValidation;
      $[26] = sortActionsWrapper;
      $[27] = t11;
      $[28] = t12;
      $[29] = topMargin;
      $[30] = t13;
    } else {
      t13 = $[30];
    }
    return t13;
  }
  let t11;
  if ($[31] !== topMargin) {
    t11 = {
      mt: topMargin,
      mb: "1.25rem",
      gap: 1
    };
    $[31] = topMargin;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const t12 = shouldStack ? "column" : "row";
  const t13 = shouldStack ? "flex-start" : "space-between";
  const t14 = shouldStack ? "stretch" : "start";
  let t15;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t14) {
    t15 = {
      flexDirection: t12,
      justifyContent: t13,
      alignItems: t14
    };
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  const t16 = shouldStack ? "column" : "row";
  const t17 = shouldStack ? "stretch" : "start";
  const t18 = shouldStack ? "0.75rem" : 0;
  let t19;
  if ($[37] !== t17 || $[38] !== t18) {
    t19 = {
      alignItems: t17,
      gap: t18
    };
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== shouldSkipValidation || $[41] !== shouldStack) {
    t20 = <Searchbar shouldFullWidth={shouldStack} shouldSkipValidation={shouldSkipValidation} />;
    $[40] = shouldSkipValidation;
    $[41] = shouldStack;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== exportComponent || $[44] !== rowsLabel || $[45] !== shouldStack || $[46] !== sortAndFilterActions) {
    t21 = shouldStack ? <Stack direction="row" sx={{
      justifyContent: "space-between",
      alignItems: "center",
      gap: 2
    }}>{sortAndFilterActions}<Stack direction="row" sx={{
        alignItems: "center",
        gap: 2
      }}>{rowsLabel}{exportComponent}</Stack></Stack> : sortAndFilterActions;
    $[43] = exportComponent;
    $[44] = rowsLabel;
    $[45] = shouldStack;
    $[46] = sortAndFilterActions;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t16 || $[49] !== t19 || $[50] !== t20 || $[51] !== t21) {
    t22 = <Stack direction={t16} sx={t19}>{t20}{t21}</Stack>;
    $[48] = t16;
    $[49] = t19;
    $[50] = t20;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== exportComponent || $[54] !== rowsLabel || $[55] !== shouldStack) {
    t23 = !shouldStack && <Stack direction="row" sx={{
      alignItems: "center",
      minHeight: TOOLBAR_ROW_HEIGHT,
      gap: 2
    }}>{rowsLabel}{exportComponent}</Stack>;
    $[53] = exportComponent;
    $[54] = rowsLabel;
    $[55] = shouldStack;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t15 || $[58] !== t22 || $[59] !== t23) {
    t24 = <Stack sx={t15}>{t22}{t23}</Stack>;
    $[57] = t15;
    $[58] = t22;
    $[59] = t23;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== filterChipsBar || $[62] !== t11 || $[63] !== t24) {
    t25 = <Stack sx={t11}>{t24}{filterChipsBar}</Stack>;
    $[61] = filterChipsBar;
    $[62] = t11;
    $[63] = t24;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  return t25;
}